require('./angular-animate');
module.exports = 'ngAnimate';



/*****************
 ** WEBPACK FOOTER
 ** ./~/angular-animate/index.js
 ** module id = 140
 ** module chunks = 0
 **/